import { createReducer, on } from '@ngrx/store'

import { AgentChatActions } from './chat.actions'
import {
  onAddInitialMessage,
  onClearMessages,
  onGetAgentResponseFailure,
  onGetAgentResponseStream,
  onGetAgentResponseStreamCompleted,
  onRedoMessage,
  onSendFeedback,
  onUserSendMessage,
} from './chat.handler'
import { initialState } from './chat.state'

export const chatReducer = createReducer(
  initialState,
  on(AgentChatActions.getAgentResponseStream, onGetAgentResponseStream),
  on(AgentChatActions.userSendMessage, onUserSendMessage),
  on(AgentChatActions.getAgentResponseFailure, onGetAgentResponseFailure),
  on(AgentChatActions.getAgentResponseStreamCompleted, onGetAgentResponseStreamCompleted),
  on(AgentChatActions.sendFeedback, onSendFeedback),
  on(AgentChatActions.redoMessage, onRedoMessage),
  on(AgentChatActions.clearMessages, onClearMessages),
  on(AgentChatActions.addInitialMessage, onAddInitialMessage)
)
